import { render, staticRenderFns } from "./adminindex.vue?vue&type=template&id=18d7881b&scoped=true&"
import script from "./adminindex.vue?vue&type=script&lang=js&"
export * from "./adminindex.vue?vue&type=script&lang=js&"
import style0 from "./adminindex.vue?vue&type=style&index=0&id=18d7881b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d7881b",
  null
  
)

export default component.exports